import { useEffect, useRef } from "react";
import ReactPortal from "../ReactPortal";
import styled from "styled-components";
import Trade from "./Trade";

function Modal({ children, isOpen, handleClose, token }) {
  useEffect(() => {
    const closeOnEscapeKey = (e) => (e.key === "Escape" ? handleClose() : null);
    document.body.addEventListener("keydown", closeOnEscapeKey);
    return () => {
      document.body.removeEventListener("keydown", closeOnEscapeKey);
    };
  }, [handleClose]);

  const noop = (e) => {
    e.stopPropagation();
  };

  return (
    <ReactPortal wrapperId="react-portal-modal-container">
      {isOpen && (
        <ModalWrapper onClick={handleClose}>
          <ModalInner onClick={noop}>
            <Trade handleClose={handleClose} token={token}/>
					</ModalInner>
        </ModalWrapper>
      )}
    </ReactPortal>
  );
}
export default Modal;

const ModalWrapper = styled.div`
  position: fixed;
  background: rgba(27, 27, 27, 0.8);
  z-index: 10;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const ModalInner = styled.div`
  position: absolute;
  z-index: 10;
  background: #000;
  color: #fff;
  width: 479px;
  min-height: 417px;
	left: 50%;
	top: 20vh;
	transform: translateX(-50%);
  background: #000;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  border-radius: 16px;
`;


